import { RootState } from '@/store';

const $rootAuth = (state: RootState) => state.globals;

export const $route = (state: RootState) => $rootAuth(state).route;
export const $breadCrumbsRoute = (state: RootState) => $route(state).breadCrumbsRoute;
